import ViewsApproval from '@/views/approval/ViewsApproval.vue';
import ViewsDelegate from '@/views/approval/ViewsDelegate.vue';
import ViewsEmployees from '@/views/approval/ViewsEmployees.vue';

import {PERMISSIONS} from '@/constants';
import {home} from '@/router/breadcrumbs';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/approvals',
        name: 'approvals',
        component: ViewsApproval,
        meta: {
            requiresAuth: true,
            breadcrumbs: [home, {text: 'approvals'}],
            permissions: [PERMISSIONS.MANAGER]
        }
    },
    {
        path: '/approvals/delegate',
        name: 'approvals.delegate',
        component: ViewsDelegate,
        meta: {
            requiresAuth: true,
            breadcrumbs: [home, {text: 'delegate'}],
            permissions: [PERMISSIONS.MANAGER]
        }
    },
    {
        path: '/approvals/my-employees',
        name: 'approvals.employees',
        component: ViewsEmployees,
        meta: {
            requiresAuth: true,
            breadcrumbs: [home, {text: 'employees'}],
            permissions: [PERMISSIONS.MANAGER]
        }
    }
] as RouteRecordRaw[]